import { render } from "./partnerRate.vue?vue&type=template&id=1f9b6cc8&scoped=true"
import script from "./partnerRate.vue?vue&type=script&lang=js"
export * from "./partnerRate.vue?vue&type=script&lang=js"

import "@/styles/striNew.css?vue&type=style&index=0&id=1f9b6cc8&scoped=true&lang=css"
import "./partnerRate.vue?vue&type=style&index=1&id=1f9b6cc8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9b6cc8"]])

export default __exports__